import React from 'react';
import adminLogo from '../../../image/admin-logo.png';
import { connect } from 'react-redux';
import { withRouter, Link } from "react-router-dom";
import $ from 'jquery';
class SideMenu extends React.Component {
    constructor(props) {
        super(props);
        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            userData: JSON.parse(localStorage.getItem('userData'))
        };
        this.subMenu = this.subMenu.bind(this)
    }

    componentWillMount() {
        const { userData } = this.state
        console.log("userData", userData);
        if (localStorage.getItem('userLogin') === "true" && userData.userType !== "admin") {
            this.props.history.push({
                pathname: '/error',
            });
        }
    }

    componentDidMount() {
        //this.props
        const { location } = this.props
        var path = location.pathname.split("/");
        //alert(path[2]);
        this.menuClick(path[2]);
        if (location.pathname === "/admin/home/" || location.pathname === "/admin/home") {
            this.menuClick("home");
        }
        console.log("this.props", this.props);
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    subMenu = (menu) => {
        console.log("menu", menu);
        this.props.history.push({
            pathname: menu,
        });
    }

    menuClick = (type, e) => {
        console.log("type", type);
        if (type === "logout") {
            localStorage.removeItem('userLogin')
            this.props.history.push({
                pathname: "/admin/",
                state: { "fieldSelct": this.state.fieldSelct }
            });
            window.location.reload();
        }
        $("li").removeClass("active");
        setTimeout(function() {
            $("#" + type).addClass('active')
        }, 300);
    }

    render() {
        return (
            <nav id="sidebar">
                <div className="sidebar-header">
                    <Link to={{ pathname: `/admin/home/` }}>
                        <img src={adminLogo} alt="logo"/>
                    </Link> 
                </div>
                <ul className="list-unstyled components">
                    <li id="home">
                        <Link to={{ pathname: `/admin/home`}} onClick={this.menuClick.bind(this,"home")}>Dashboard</Link>
                    </li>

                    <li  id="category">
                        <Link to={{ pathname: `/admin/category`}} onClick={this.menuClick.bind(this,"category")}> Category</Link>
                    </li>

                    <li id="masters">
                            <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">Masters</a>
                        <ul className="collapse list-unstyled" id="pageSubmenu">
                            <li>
                              <Link to={{ pathname: `/admin/add-city`}} onClick={this.menuClick.bind(this,"masters")}>Add City</Link>
                              <Link to={{ pathname: `/admin/view-city` }} onClick={this.menuClick.bind(this,"masters")}>View City</Link>
                            </li>
                        </ul>
                    </li>  

                    <li id="users">
                            <a href="#pageSubmenuUsers" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">Users</a>
                        <ul className="collapse list-unstyled" id="pageSubmenuUsers">
                            <li>
                              <Link to={{ pathname: `/admin/jobProvider`}} onClick={this.menuClick.bind(this,"users")}>Job Provider</Link>
                              <Link to={{ pathname: `/admin/jobSeekers` }} onClick={this.menuClick.bind(this,"users")}> Job Seekers</Link>
                            </li>
                        </ul>
                    </li>
                    <li id="resumeActivity">
                        <Link to={{ pathname: `/admin/resume-list`}} onClick={this.menuClick.bind(this,"resumeActivity")}> Resume Activity </Link>
                    </li>
                    <li id="blog">
                            <a href="#pageSubmenuBlog" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">Blog</a>
                        <ul className="collapse list-unstyled" id="pageSubmenuBlog">
                            <li>
                              <Link to={{ pathname: `/admin/blog-list`}} onClick={this.menuClick.bind(this,"blog")}>Blog List</Link>
                              <Link to={{ pathname: `/admin/blog-add` }} onClick={this.menuClick.bind(this,"blog")}>Blog Add</Link>
                            </li>
                        </ul>
                    </li>

                    
                    <li id="contact-us">
                        <Link to={{ pathname: `/admin/contact-us`}} onClick={this.menuClick.bind(this,"contact-us")}> Contact-us </Link>
                    </li>
                    <li id="getIntouch">
                        <Link to={{ pathname: `/admin/getIntouch-contact`}} onClick={this.menuClick.bind(this,"getIntouch-contact")}> Get In Touch Contact </Link>
                    </li>

                    <li>
                        <Link onClick={this.menuClick.bind(this,"logout")} ><i className="fa fa-power-off" aria-hidden="true" ></i>&nbsp;Logout</Link>
                    </li>
               
                </ul>
            </nav>
        );
    }
}




function mapStateToProps(state) {
    return {
        fields: state.home.response.data
    };
}
export default withRouter(connect(mapStateToProps, {

})(SideMenu));
//export default SubMenu;


// WEBPACK FOOTER //
// ./src/components/Admin/sidebar/SidebarCustom.js